import React, { useRef } from 'react';

import {
	type IframeSearchPageProps,
	type QueryParams,
	SEARCH_PAGE_QUERY_PARAM_KEYS,
} from './types';

const setIframeQueryParams = (queryParams: QueryParams) => {
	let queryParts: string[] = [];
	SEARCH_PAGE_QUERY_PARAM_KEYS.forEach((key) => {
		const value = queryParams[key];
		if (value === undefined) {
			// Skip keys with undefined values
			return;
		}
		if (Array.isArray(value)) {
			// Handle array values by appending multiple key=value pairs
			value.forEach((item) => {
				if (item !== undefined) {
					// Check item is not undefined
					queryParts.push(`${encodeURIComponent(key)}=${encodeURIComponent(item)}`);
				}
			});
		} else if (typeof value === 'boolean') {
			// Handle boolean values by converting them to strings
			queryParts.push(`${encodeURIComponent(key)}=${encodeURIComponent(value.toString())}`);
		} else {
			// Handle string values directly
			queryParts.push(`${encodeURIComponent(key)}=${encodeURIComponent(value)}`);
		}
	});
	return queryParts.join('&');
};
export const IframeSearchPage = ({
	queryString,
	searchSessionId,
	queryParams,
}: IframeSearchPageProps): React.JSX.Element => {
	const iframeRef = useRef<HTMLIFrameElement>(null);
	const baseUrl = window.location.href.split('?');
	const filterQueryString = setIframeQueryParams(queryParams);
	return (
		// eslint-disable-next-line @atlassian/a11y/iframe-has-title
		<iframe
			ref={iframeRef}
			src={`${baseUrl[0]}?text=${queryString}&isIFramePage=true&searchSessionId=${searchSessionId}&${filterQueryString}`}
			// eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
			style={{ border: 'none', height: '100%', width: '100%', marginTop: '-80px' }}
		/>
	);
};
